import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setPrismicToken } from '../../store/prismic'
import { fetchDocument } from 'prismic-utils'

import Error from '../../components/ui/Error'
import Loading from '../../components/ui/Loading'
import Section from 'constructicon/section'

class Preview extends Component {
  constructor () {
    super()
    this.state = {
      status: 'fetching'
    }
  }

  componentDidMount () {
    const { location, router, setPrismicToken } = this.props
    const { repo, token } = location.query

    fetchDocument({ repository: repo, token })
      .then((doc) => this.getSiteUID(doc))
      .then((uid) => setPrismicToken({ repo, token, uid }))
      .then(() => router.push('/'))
      .catch((error) => {
        this.setState({ status: 'failed' })
        return Promise.reject(error)
      })
  }

  getSiteUID (document) {
    switch (document.type) {
      case 'internal_page':
        return document.data.site.uid
      default:
        return document.uid
    }
  }

  render () {
    return (
      <Section>
        {this.state.status === 'fetching' && <Loading />}
        {this.state.status === 'failed' && <Error />}
      </Section>
    )
  }
}

export default connect(null, { setPrismicToken })(Preview)



// WEBPACK FOOTER //
// ./routes/Preview/index.js